export const TIMEZONES = [
    "Pacific/Midway (UTC-11)",
    "Pacific/Honolulu (UTC-10)",
    "America/Anchorage (UTC-9)",
    "America/Los_Angeles (UTC-8)",
    "America/Denver (UTC-7)",
    "America/Chicago (UTC-6)",
    "America/New_York (UTC-5)",
    "America/Halifax (UTC-4)",
    "America/Sao_Paulo (UTC-3)",
    "Atlantic/South_Georgia (UTC-2)",
    "Atlantic/Azores (UTC-1)",
    "Europe/London (UTC+0)",
    "Europe/Paris (UTC+1)",
    "Europe/Helsinki (UTC+2)",
    "Europe/Moscow (UTC+3)",
    "Asia/Dubai (UTC+4)",
    "Asia/Karachi (UTC+5)",
    "Asia/Kolkata (UTC+5:30)",
    "Asia/Dhaka (UTC+6)",
    "Asia/Bangkok (UTC+7)",
    "Asia/Singapore (UTC+8)",
    "Asia/Tokyo (UTC+9)",
    "Australia/Sydney (UTC+10)",
    "Pacific/Noumea (UTC+11)",
    "Pacific/Auckland (UTC+12)"
];

export const TIMEZONE_ALIASES = {
    "HST (UTC-10)": "Pacific/Honolulu (UTC-10)",
    "AKST (UTC-9)": "America/Anchorage (UTC-9)",
    "PST (UTC-8)": "America/Los_Angeles (UTC-8)",
    "MST (UTC-7)": "America/Denver (UTC-7)",
    "CST (UTC-6)": "America/Chicago (UTC-6)",
    "EST (UTC-5)": "America/New_York (UTC-5)",
    "AST (UTC-4)": "America/Halifax (UTC-4)",
    "GMT (UTC+0)": "Europe/London (UTC+0)",
    "UTC (UTC+0)": "Europe/London (UTC+0)",
    "BST (UTC+1)": "Europe/Paris (UTC+1)",
    "CET (UTC+1)": "Europe/Paris (UTC+1)",
    "CEST (UTC+2)": "Europe/Helsinki (UTC+2)",
    "EET (UTC+2)": "Europe/Helsinki (UTC+2)",
    "EEST (UTC+3)": "Europe/Moscow (UTC+3)",
    "MSK (UTC+3)": "Europe/Moscow (UTC+3)",
    "IST (UTC+5.5)": "Asia/Kolkata (UTC+5:30)",
    "AWST (UTC+8)": "Asia/Singapore (UTC+8)",
    "JST (UTC+9)": "Asia/Tokyo (UTC+9)",
    "KST (UTC+9)": "Asia/Tokyo (UTC+9)",
    "ACST (UTC+9.5)": "Australia/Sydney (UTC+10)",
    "AEST (UTC+10)": "Australia/Sydney (UTC+10)",
    "NZST (UTC+12)": "Pacific/Auckland (UTC+12)"
};

export const GRADES = [
    "Prefer not to say", "Junior", "Middle", "Senior", "Lead / Head of",
    "C-Level Executive", "Founder", "Entrepreneur"
];

export const LANGUAGES = ["English", "Russian", "Spanish", "French", "German", "Italian", "Swedish", "Ukrainian", "Arabic", "Catalan"];

export const COFFEE_GOALS = ["Casual Chat", "Professional Chat"];

export const DAYS_OF_WEEK = [
    "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"
];

export const API_URL = process.env.REACT_APP_API_URL || '';

export const DAY_COLORS = {
    'Monday': '#fee2e2',
    'Tuesday': '#ffedd5',
    'Wednesday': '#fef9c3',
    'Thursday': '#dcfce7',
    'Friday': '#dbeafe',
    'Saturday': '#f3e8ff',
    'Sunday': '#fae8ff'
};

export const CHIP_BG_COLORS = [
    '#fef3f2',
    '#fff7ed',
    '#fefce8',
    '#f0fdf4',
    '#eff6ff',
    '#faf5ff',
    '#fdf4ff',
];

export const CHIP_TEXT_COLORS = [
    '#dc2626',
    '#ea580c',
    '#ca8a04',
    '#16a34a',
    '#2563eb',
    '#7c3aed',
    '#c026d3',
];

export const INITIAL_FORM_DATA = {
    name: '',
    family: '',
    country: null,
    city: null,
    timezone: 'Europe/London (UTC+0)',
    bestMeetingDays: [],
    languages: [],
    profession: '',
    grade: 'Prefer not to say',
    professionalDesc: '',
    personalDesc: '',
    professionalInterests: [],
    otherProfessionalInterests: '',
    personalInterests: [],
    otherPersonalInterests: '',
    coffeeGoals: [],
    linkedin: '',
    serendipity: 5,
    proximity: 5,
    nextWeekStatus: 'Active',
    notificationsPaused: false
};

export const getAvatarUrl = (avatarPath) => {
    if (!avatarPath) return null;
    if (avatarPath.startsWith('http') || avatarPath.startsWith('data:')) return avatarPath;
    return `${API_URL}${avatarPath}`;
};

export const getChipStyle = (() => {
    const cache = new Map();
    return (str) => {
        if (cache.has(str)) return cache.get(str);
        let hash = 0;
        for (let i = 0; i < str.length; i++) {
            hash = str.charCodeAt(i) + ((hash << 5) - hash);
        }
        const index = Math.abs(hash) % CHIP_BG_COLORS.length;
        const style = {
            backgroundColor: CHIP_BG_COLORS[index],
            color: CHIP_TEXT_COLORS[index]
        };
        cache.set(str, style);
        return style;
    };
})();
